import { Component } from '@angular/core';

@Component({
  selector: 'app-cr',
  template: `<app-audit-category sectionKey="cr"></app-audit-category>`,
})
export class CrComponent {}
